export enum IdentityStatusesEnum {
  PRIORITY = "PRIORITY",
  NOT_PRIORITY = "NOT_PRIORITY",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  CREATED = "CREATED",
  APPROVE = "APPROVE",
}
